import React from 'react'

interface BrandIconProps {
  size?: number
  color?: string
  style?: React.CSSProperties
  className?: string
}

export const FacebookIcon = ({
  size = 24,
  color = 'currentColor',
  ...props
}: BrandIconProps) => (
  <svg
    viewBox="0 0 24 24"
    width={size}
    height={size}
    fill={color}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z" />
  </svg>
)

export const XIcon = ({
  size = 24,
  color = 'currentColor',
  ...props
}: BrandIconProps) => (
  <svg
    viewBox="0 0 24 24"
    width={size}
    height={size}
    fill={color}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M18.901 1.153h3.68l-8.04 9.19L24 22.846h-7.406l-5.8-7.584-6.638 7.584H.474l8.6-9.83L0 1.154h7.594l5.243 6.932 6.064-6.932zm-1.292 19.49h2.039L6.486 3.24H4.298l13.311 17.403z" />
  </svg>
)

export const ThreadsIcon = ({
  size = 24,
  color = 'currentColor',
  ...props
}: BrandIconProps) => (
  <svg
    viewBox="0 0 24 24"
    width={size}
    height={size}
    fill="none"
    stroke={color}
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M10 13a3.5 3.5 0 0 0 4 0" />
    <path d="M12 11.5a3.5 3.5 0 1 0 3.5 3.5" />
    <circle cx="12" cy="12" r="10" />
  </svg>
)
